import React from 'react';
import { AlertCircle, X } from 'lucide-react';

interface AlertModalProps {
  title: string;
  message: string;
  confirmText?: string;
  onClose: () => void;
  onConfirm?: () => void;
}

export default function AlertModal({ title, message, confirmText, onClose, onConfirm }: AlertModalProps) {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm w-full mx-4 text-center relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-ink-muted hover:text-brand-900 transition-colors"
        >
          <X size={18} />
        </button>
        <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-amber-50 flex items-center justify-center">
          <AlertCircle className="w-7 h-7 text-amber-500" />
        </div>
        <h3 className="text-lg font-bold text-brand-900 mb-2">{title}</h3>
        <p className="text-sm text-ink-secondary mb-6 leading-relaxed">{message}</p>
        <button
          onClick={onConfirm || onClose}
          className="w-full py-3 bg-brand-900 text-white rounded-full font-semibold hover:bg-brand-800 transition-colors"
        >
          {confirmText || 'OK'}
        </button>
      </div>
    </div>
  );
}
